jQuery(document).ready(function ($) {
  $(".site-top-bar__sites ul > li > a").click(function (e) {
    $(this).next("ul").toggle();
    e.stopPropagation();
  });

  $(".site-top-bar__sites ul ul").click(function (e) {
    e.stopPropagation();
  });

  $(".hamburger").on("click", function (e) {
    $(this).toggleClass("hamburger-is-active");
    $(".site-nav").toggleClass("hamburger-is-active");
    $("body").toggleClass("hamburger-is-active");
  });

  $(document).click(function () {
    $(".site-top-bar__sites ul ul").hide();
  });

  //Showing caption + alignment on images added within editor
  $("img[data-caption]").each(function () {
    var caption = $(this).attr("data-caption");
    var align = $(this).attr("data-align");

    $(this).wrap('<figure class="figure" />'); //wrapping image in figure tag
    $(this).parent("figure").append('<figcaption class="figure__caption" />'); //adding caption tag
    $(this).removeAttr("data-align"); //removing align data from image to avoid css issues

    $(this).parent("figure").attr("data-align", align); //adding alignment on figure
    $(this).next("figcaption").append(caption); //adding caption within tag
  });

  //Items per page form
  $(".js-form-item-items-per-page select").on("change", function () {
    $(this).closest("form").submit();
  });

  //Accordion Simple list
  $(".accordion-list__title:first").addClass("open");
  var openOnLoad = $(".accordion-list__title:first").next(
    ".accordion-list__content"
  );
  $(openOnLoad).slideDown();

  $(".accordion-list__title").on("focus", function () {
    if (!$(this).data("mouseDown")) $(this).click();
  });

  $(".accordion-list__title").on("mousedown", function () {
    $(this).data("mouseDown", true);
  });

  $(".accordion-list__title").on("mouseup", function () {
    $(this).removeData("mouseDown");
  });

  $(".accordion-list__title").on("click", function (e) {
    if ($(this).hasClass("open")) {
      //Close the current section
      $(".accordion-list__title").removeClass("open");
      $(".accordion-list__content").slideUp();
    } else {
      //close the prev section & open the newly click
      $(".accordion-list__title").removeClass("open");
      $(".accordion-list__content").slideUp(); //Side up all sections that are open & remove their open class
      $(this).addClass("open");
      var sectionToOpen = $(this).next(".accordion-list__content");
      $(sectionToOpen).slideDown();
    }
  });

  //Replacing outputted "&amp; with &" from feed icon link
  var el = $("a.feed-icon");
  if (el.length > 0) {
    el.html(el.html().replace("&amp;", "&"));
  }

  // init Masonry after all images have loaded
  var $grid = $(".home__masonry").imagesLoaded(function () {
    $grid.masonry({
      percentPosition: true,
    });
  });
});
